module.exports = __webpack_public_path__ + "static/img/bm.5d6517e1.svg";